import { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

export const ScrollToSection = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const scrollToElement = () => {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          requestAnimationFrame(scrollToElement);
        }
      };

      scrollToElement();
    }
  }, [hash]);

  return null;
};

const StyledReactMarkdown = styled(ReactMarkdown)`
    * 
    {
        line-height: 1.75;
    }

    &&
    {
        font-size: var(--size-smaller);
    }

    ul, p, h1, h2, h3, && ul > li
    {
        padding: unset;
        margin: unset;
    }

    
    
    table, td, th, tr
    {
        border-collapse: collapse;
        border: 1px solid var(--color-primary-dark);
    }

    td, th, tr
    {
        padding: 4px 12px;
    }

    ul, h1, h2, h3, table
    {
        margin: 16px 0;
    }

    ul
    {
        margin-left: 2rem;
        list-style-type: unset;
    }

    h1
    {
        font-size: var(--size-header);
    }

    h2, h3
    {
        font-size: var(--size-main);
    }

    ul, p
    {
        font-size: var(--size-smaller);
        max-width: 80ch;
        line-height: 1.5;
    }

    table
    {
        display: block;
        font-size: var(--size-smaller);
        line-height: 1.5;
        width: 100%;
        overflow-x: scroll;
        border: none;
    }


    a
    {
        color: var(--color-primary);
        text-decoration: underline;
    }

    hr
    {
        margin: 2em 0;
    }
`;

export default StyledReactMarkdown;
